const Mood = Object.freeze({
  SURPRISE: 'SURPRISE',
  DESIRE: 'DESIRE',
  EXCITEMENT: 'EXCITEMENT',
  JOY: 'JOY',
  AMUSEMENT: 'AMUSEMENT',
  LOVE: 'LOVE',
  TRUST: 'TRUST',
  LOYALTY: 'LOYALTY',
  FEAR: 'FEAR',
  SHOCK: 'SHOCK',
  SUSPICION: 'SUSPICION',
  SADNESS: 'SADNESS',
  NOSTALGIA: 'NOSTALGIA',
  DISGUST: 'DISGUST',
  HATRED: 'HATRED',
  ANGER: 'ANGER'
})
export default Mood
// RESERVE BELOW
